import React, { useState, useEffect } from 'react';
import "../../components/Cart/Cart.css";
import EnquiryModal from '../DashboardModule/EnquiryModal';

const Cart = () => {
  const [cartItems, setCartItems] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
 
   const openModal = () => {
     setIsModalOpen(true); // Open modal
   };
 
   const closeModal = () => {
     setIsModalOpen(false); // Close modal
   };
   
  useEffect(() => {
    try {
      const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
      const normalizedItems = storedCartItems.map(item => ({
        ...item,
        quantity: item.quantity || 1
      }));
      setCartItems(normalizedItems);
    } catch (error) {
      console.error('Failed to load cart items:', error);
      setCartItems([]);
    }
  }, []);

  const handleQuantityChange = (id, action) => {
    setCartItems(prevItems => {
      const updatedItems = prevItems.map(item => {
        if (item.id === id) {
          const newQuantity = action === "increase" 
            ? item.quantity + 1 
            : Math.max(1, item.quantity - 1);
          return { ...item, quantity: newQuantity };
        }
        return item;
      });
      localStorage.setItem('cartItems', JSON.stringify(updatedItems));
      return updatedItems;
    });
  };

  const handleDelete = (id) => {
    try {
      setCartItems(prevItems => {
        const updatedItems = prevItems.filter(item => item.id !== id);
        localStorage.setItem('cartItems', JSON.stringify(updatedItems));
        return updatedItems;
      });
    } catch (error) {
      console.error('Failed to remove item:', error);
    }
  };

  const totalPrice = cartItems.reduce(
    (sum, item) => sum + (item.price * item.quantity), 
    0
  );

  return (
    <div className="cart-container">
      <header className="breadcrumb">
        <nav className='font-poppins' aria-label="Breadcrumb">
          <a href="/">Home</a> &gt; <span>My Cart</span>
        </nav>
      </header>

      <main className="cart-main">
        <section className="cart-items-section">
          <h2 className="cart-title">
            {cartItems.length} {cartItems.length === 1 ? 'Item' : 'Items'} in your cart
          </h2>
          
          {cartItems.length === 0 ? (
            <p className="empty-cart">Your cart is empty</p>
          ) : (
            <div className="cart-table">
              <div className="table-header">
                <div className="header-item">Item</div>
                <div className="header-requirements">Requirements</div>
                <div className="header-quantity">W1</div>
                <div className="header-result">Result</div>
              </div>
              
              {cartItems.map((item) => (
                <div key={item.id} className="table-row">
                  <div className="row-item">
                    <div className="item-image">
                      <img 
                        src={item.image || "https://via.placeholder.com/80"} 
                        alt={item.name} 
                        width="80"
                        height="80"
                        loading="lazy"
                      />
                    </div>
                    <div className="item-info">
                      <h3>{item.name}</h3>
                    </div>
                  </div>
                  <div className="row-requirements">
                    <p>Type: {item.type}</p>
                    <p>Size: {item.size}</p>
                  </div>
                  <div className="row-quantity">
                    <div className="quantity-controls">
                      <button 
                        onClick={() => handleQuantityChange(item.id, 'decrease')} 
                        disabled={item.quantity <= 1}
                        aria-label="Decrease quantity"
                      >
                        -
                      </button>
                      <span aria-live="polite">{item.quantity}</span>
                      <button 
                        onClick={() => handleQuantityChange(item.id, 'increase')} 
                        aria-label="Increase quantity"
                      >
                        +
                      </button>
                    </div>
                  </div>
                  <div className="row-result">
                    {/* <span className="item-price">${(item.price * item.quantity).toFixed(2)}</span> */}
                    <button 
                      className="delete-btn" 
                      onClick={() => handleDelete(item.id)}
                      aria-label={`Remove ${item.name} from cart`}
                    >
                      ×
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </section>

        {cartItems.length > 0 && (
          <aside className="cart-summary">
            <h3 className="summary-title">Order Summary</h3>
            
            <div className="summary-section">
              {/* <div className="summary-row">
                <span>Subtotal</span>
                <span>${totalPrice.toFixed(2)}</span>
              </div>
              <div className="summary-row">
                <span>Shipping</span>
                <span>$0.00</span>
              </div> */}
              {/* <div className="summary-row total">
                <span>Total</span>
                <span>${totalPrice.toFixed(2)}</span>
              </div> */}
            </div>

            <div className="payment-section">
              <label htmlFor="payment-term">Payment Term</label>
              <select id="payment-term" aria-label="Select payment term">
                <option value="advance">Advance</option>
                <option value="cod">Cash on Delivery</option>
              </select>
            </div>

            <button className="checkout-btn" aria-label="Proceed to checkout"  onClick={openModal}>
              Proceed to Checkout    
            </button>
            {isModalOpen && <EnquiryModal onClose={closeModal} />}

          </aside>
        )}
      </main>
    </div>
  );
};

export default Cart;